module.exports = __webpack_public_path__ + "img/outlook.2ca0a373.png";